import { SVGProps } from 'react';

interface ChartBarIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * Chart Bar Icon
 *
 * Represents progress tracking and analytics features.
 * Bar chart design showing growth/progress.
 */
export function ChartBarIcon({ size = 24, ...props }: ChartBarIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3"
        y="12"
        width="4"
        height="9"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="10"
        y="7"
        width="4"
        height="14"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="17"
        y="3"
        width="4"
        height="18"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M5 9L12 5L19 2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="2 2"
      />
    </svg>
  );
}
